// Contract configuration
export const CONTRACT_ADDRESS = "0xF474DdD8fc0CAdA758F92c37aB6A565eC9e63935";

export const CONTRACT_ABI = [
  "function mintFlightNFT(address recipient, string memory tokenURI, bytes32 dataHash) public payable returns (uint256)",
  "function mintPrice() public view returns (uint256)",
  "function totalSupply() public view returns (uint256)",
  "function tokenURI(uint256 tokenId) public view returns (string)",
  "function ownerOf(uint256 tokenId) public view returns (address)",
];

export const BASE_CHAIN_ID = 8453n;
export const BASE_CHAIN_ID_HEX = "0x2105";

export const BASE_NETWORK_CONFIG = {
  chainId: BASE_CHAIN_ID_HEX,
  chainName: "Base",
  nativeCurrency: {
    name: "Ethereum",
    symbol: "ETH",
    decimals: 18,
  },
  rpcUrls: ["https://mainnet.base.org"],
  blockExplorerUrls: ["https://basescan.org"],
};

export const MINT_PRICE_ETH = 0.0001;
